export default "__VITE_ASSET__s3Ur4L90__"